import React, {Component} from 'react';
import {FormattedMessage} from "react-intl";
import Slider from "react-slick";
import JobCard from "./JobCard";
import { handlePublicRequestError, Request } from '../../../helpers/request'


class JobsInterestSection extends Component
{
    state = {
        offers: null
    };

    componentDidMount() {
        this.fetch();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.linked_job_orders !== prevProps.linked_job_orders) {
            this.fetch()
        }
    }

    fetch() {
        this.setState({ offers: this.props?.linked_job_orders ?? null })
    }

    render() {

        const { offers } = this.state;

        if (!offers || offers.length === 0) return null;

        const settings = {
            dots: true,
            infinite: true,
            arrows: false,
            slidesToShow: offers.length,
            slidesToScroll: 3,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        adaptiveHeight: false
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        adaptiveHeight: false
                    },
                },
            ]
        };

        return (
            <section className="interest-section">
                <div className="container">
                    <h2>
                        <FormattedMessage
                            id="portfolio.job_detail.interest"
                            defaultMessage="Les postes qui peuvent vous intéresser"
                        />
                    </h2>
                    <Slider className="interest-slider" {...settings}>
                        {offers.map((offer) => this.renderOffer(offer))}
                    </Slider>
                </div>
            </section>
        )
    }

    renderOffer(offer) {
        return (
            <div className="slide-item" key={offer.id}>
                <JobCard offer={offer}/>
            </div>
        )
    }
}

export default JobsInterestSection;
